// Href seguro para links que escribe un usuario (redes, sitio web, link de
// entradas, link del post publicado, link de una canción).
//
// React 18 no bloquea un href "javascript:": solo lo advierte en consola. Si
// uno de esos campos guardara "javascript:…", un clic de otro usuario —un
// difusor, o el admin en Verificaciones— ejecutaría código con su sesión,
// que vive en localStorage. El backend ya valida los campos nuevos, pero las
// pantallas de edición de perfil aceptan texto libre y puede haber datos
// viejos en la base, así que la defensa va también acá, al mostrar.
//
// Devuelve el link si es http(s) —agregando https:// si no traía protocolo,
// lo que de paso arregla links como "instagram.com/x" que el navegador
// trataba como rutas internas— o undefined, que deja el link inerte.
export function hrefSeguro(valor) {
  const texto = String(valor ?? "").trim();
  if (!texto) return undefined;

  const conProtocolo = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(texto)
    ? texto
    : `https://${texto}`;

  try {
    const url = new URL(conProtocolo);
    return ["http:", "https:"].includes(url.protocol) ? url.toString() : undefined;
  } catch (e) {
    return undefined;
  }
}
